"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ValueSet_Compose = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_date_1 = require("../Scalar/RTTI_date");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_ValueSet_Include_1 = require("./RTTI_ValueSet_Include");
exports.RTTI_ValueSet_Compose = t.recursion('IValueSet_Compose', function () {
    return t.intersection([
        t.type({
            include: t.array(RTTI_ValueSet_Include_1.RTTI_ValueSet_Include)
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            lockedDate: RTTI_date_1.RTTI_date,
            _lockedDate: RTTI_Element_1.RTTI_Element,
            inactive: t.boolean,
            _inactive: RTTI_Element_1.RTTI_Element,
            exclude: t.array(RTTI_ValueSet_Include_1.RTTI_ValueSet_Include)
        })
    ]);
});
//# sourceMappingURL=RTTI_ValueSet_Compose.js.map